// extracted by mini-css-extract-plugin
module.exports = {"photocredit":"dh-dh-klima-spesial-english-photocredit--3ecdc62c004ffbeb332afa71d2239f7c","wrapper":"dh-dh-klima-spesial-english-wrapper--6cd06936397f106d7a8df519111573d2"};